module.exports = __webpack_public_path__ + "static/media/profile-1.0734b387.svg";